export const PRIVACY_POLICY_LINK = 'https://www.cian.ru/legal-documents/politika_konfidencialnosti_0/';
